import { citiesUrl, sectionsUrl } from "./apicarto";

export const MIN_ZOOM = 10;
export const MIN_SECTIONS_ZOOM = 14;
export const MIN_PARCELS_ZOOM = 16;

function boundsArgs(map) {
  const [[swLon, swLat], [neLon, neLat]] = map.getBounds().toArray();
  return [swLon, swLat, neLon, neLat];
}

export function sectionsUrlFromMap(map) {
  return sectionsUrl(...boundsArgs(map));
}

export function citiesUrlFromMap(map) {
  return citiesUrl(...boundsArgs(map));
}

export function addCadastreOverlays(map, { color = "#00008B" } = {}) {
  map.addSource("sections", {
    type: "geojson",
    data: sectionsUrlFromMap(map),
  });

  map.addLayer({
    id: "sections-line",
    type: "line",
    source: "sections",
    paint: {
      "line-color": color,
      "line-width": 3,
    },
    maxzoom: MIN_PARCELS_ZOOM,
    minzoom: MIN_SECTIONS_ZOOM,
  });

  map.addLayer({
    id: "sections-number",
    type: "symbol",
    source: "sections",
    layout: {
      "text-field": ["get", "section"],
      "text-variable-anchor": ["center", "top", "bottom", "left"],
    },
    paint: {
      "text-color": "#FFF",
      "text-halo-color": color,
      "text-halo-width": 2,
    },
    maxzoom: MIN_PARCELS_ZOOM,
    minzoom: MIN_SECTIONS_ZOOM,
  });

  map.addSource("cities", {
    type: "geojson",
    data: citiesUrlFromMap(map),
  });

  map.addLayer({
    id: "cities-line",
    type: "line",
    source: "cities",
    paint: {
      "line-color": color,
      "line-width": 3,
    },
    maxzoom: MIN_SECTIONS_ZOOM,
    minzoom: MIN_ZOOM,
  });

  map.addLayer({
    id: "cities-number",
    type: "symbol",
    source: "cities",
    layout: {
      "text-field": ["get", "nom_com"],
      "text-variable-anchor": ["center", "top", "bottom", "left"],
    },
    paint: {
      "text-color": "#FFF",
      "text-halo-color": color,
      "text-halo-width": 2,
    },
    maxzoom: MIN_SECTIONS_ZOOM,
    minzoom: MIN_ZOOM,
  });
}

export function updateCadastreOverlays(map) {
  map.getSource("sections").setData(sectionsUrlFromMap(map));
  map.getSource("cities").setData(citiesUrlFromMap(map));
}
